import PropTypes from 'prop-types';
import { Card, Row, Col, Image } from 'react-bootstrap';
import classNames from 'classnames';
import editIcon from 'assets/img/edit-icon.svg';
import './styles.scss';

export default function CardComponent({
  title,
  description,
  children,
  className = '',
  contentClassName = '',
  bodyClassName: bodyClass = '',
  variant = '',
  editAlt = 'Editar',
  onClickEdit,
}) {
  const isEdit = variant === 'edit';

  const bodyClassName = classNames(isEdit && 'mt-3', bodyClass);

  return (
    <Card className={`Card ${className}`}>
      {isEdit && (
        <Row className="Card__Edit">
          <Col />
          <Col
            xs={2}
            className="d-flex justify-content-center align-items-center mt-1"
          >
            <Image
              src={editIcon}
              alt={editAlt}
              className="pointer"
              onClick={onClickEdit}
            />
          </Col>
        </Row>
      )}

      <Card.Body className={bodyClassName}>
        {title && (
          <Card.Title>
            <h4 className="Card__Title text-primary text-center font-weight-bold">
              {title}
            </h4>
          </Card.Title>
        )}
        {description && <Card.Text>{description}</Card.Text>}

        <Row>
          <Col xs={12} className={contentClassName}>
            {children}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

CardComponent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  variant: PropTypes.string,
  editAlt: PropTypes.string,
};
